import { useState } from 'react';
import { Icon } from '../../../../core/components/atoms/Icon';
import { Typography } from '../../../../core/components/molecules/Typography';
import { useNavigate } from 'react-router-dom';
import { Input } from '../../../../core/components/atoms/Input';

export function EmptySearch() {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');

  const onSearch = () => {
    const baseUrl = '/search/' + searchTerm;
    navigate(baseUrl);
  };

  return (
    <div className='flex flex-col items-center xs:mb-0 md:mb-10 lg:mb-0'>
      <div className='flex w-full flex-col items-center justify-center gap-xxl'>
        <Typography variant='italic' className='text-center'>
          Não encontramos nenhum resultado para sua busca
        </Typography>
        <div className='relative w-full'>
          <div className='m-auto h-64 w-64 rounded-circular bg-mono-color-light' />
          <div className='absolute top-14 flex h-full w-full flex-col items-center gap-lg'>
            <div className='ml-10 flex h-fit flex-row items-center gap-lg rounded-md bg-mono-color-white p-2 shadow-level-1 xs:w-[250px] md:w-[260px]'>
              <div className='flex h-12 w-12 items-center justify-center rounded-circular bg-brand-color-secondary-light'>
                <Icon
                  Icon='search'
                  type='material'
                  className='text-mono-color-white'
                />
              </div>
              <div className='flex flex-1 flex-col gap-sm'>
                <div className='h-3 w-1/3 rounded-pill bg-mono-color-lightest' />
                <div className='h-3 w-3/5 rounded-pill bg-mono-color-lighter' />
              </div>
            </div>
            <div className='mr-10 flex h-fit flex-row items-center gap-lg rounded-md bg-mono-color-white p-2 shadow-level-1 xs:w-[250px] md:w-[260px]'>
              <div className='flex h-12 w-12 items-center justify-center rounded-circular bg-brand-color-secondary-light'>
                <Icon
                  Icon='search'
                  type='material'
                  className='text-mono-color-white'
                />
              </div>
              <div className='flex flex-1 flex-col gap-sm'>
                <div className='h-3 w-1/3 rounded-pill bg-mono-color-lightest' />
                <div className='h-3 w-3/5 rounded-pill bg-mono-color-lighter' />
              </div>
            </div>
          </div>
        </div>
        <Input
          IconLeft={{
            Icon: 'search',
            type: 'material',
            className: 'text-mono-color-dark',
          }}
          placeholder='O que você está procurando?'
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.keyCode === 13) {
              onSearch();
            }
          }}
          className=' mx-2 xs:w-[250px] sm:w-[280px] lg:w-[400px]'
        />
      </div>
    </div>
  );
}
